import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import React from 'react';
import CustomButton from '../components/customButton';
import responsiveFont from '../utils/responsiveFont';

// Human-readable label for each allowed `report-action` value, used in the
// confirmation message so the client sees exactly what they are requesting.
const ACTION_LABELS = {
  'print-all': 'Print All Reports',
  'inscribe-print-all': 'Inscribe & Print All Reports',
};

const SubmitConfirmation = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mdMatches = useMediaQuery((theme) => theme.breakpoints.up('md'));

  const actionLabel =
    ACTION_LABELS[searchParams.get('report-action')] || 'the selected report action';

  React.useEffect(() => {
    document.title = 'SUBMIT REQUEST';
  });

  const handleYes = () => {
    // The submit API call is made on the status page (dummy data for now).
    navigate('/submit-status');
  };

  const handleNo = () => {
    navigate('/request-cancelled');
  };

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }}>
        <Box
          sx={{
            backgroundColor: theme.palette.menubar.main,
            width: '91%',
            height: responsiveFont(45, mdMatches),
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              color: '#fff',
              fontSize: responsiveFont(20, mdMatches),
              marginLeft: '1%',
            }}
          >
            SUBMIT REQUEST
          </Box>
        </Box>
      </Box>
      <Box mt={4} textAlign="center">
        <Typography
          sx={{
            fontWeight: '900',
            fontSize: responsiveFont(16, mdMatches),
            color: '#000000',
          }}
        >
          Confirm Your Report Action
        </Typography>
        <Typography
          sx={{
            fontSize: responsiveFont(16, mdMatches),
            color: '#000000',
            marginTop: '1%',
          }}
        >
          You are requesting{' '}
          <Box component="span" sx={{ fontWeight: '900' }}>
            {actionLabel}
          </Box>{' '}
          for all eligible items in this order.
        </Typography>
        <Typography
          sx={{
            fontSize: responsiveFont(16, mdMatches),
            color: '#000000',
            marginTop: '1%',
          }}
        >
          Once submitted, this action will be processed for each item and cannot be undone. Would
          you like to proceed?
        </Typography>
        <Box
          mt={4}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: '3%',
          }}
        >
          <CustomButton
            sx={{
              width: '17%',
              fontSize: responsiveFont(15, mdMatches),
              height: responsiveFont(32, mdMatches),
            }}
            variant="contained"
            onClick={handleYes}
          >
            YES
          </CustomButton>
          <CustomButton
            sx={{
              width: '17%',
              fontSize: responsiveFont(15, mdMatches),
              height: responsiveFont(32, mdMatches),
            }}
            variant="contained"
            onClick={handleNo}
          >
            NO
          </CustomButton>
        </Box>
      </Box>
    </>
  );
};

export default SubmitConfirmation;
